export default __webpack_public_path__ + "static/SupremeLL-Jumbo-7d46bbda5d76f00d0da8cde21df32c61.woff2";